import React from "react";
import FormGroup from "@material-ui/core/FormGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Switch from "@material-ui/core/Switch";
import { connect } from "react-redux";
import { actionCreators } from "./action";
import isMobile from "../../helpers/isMobile";
import Brightness3Icon from "@material-ui/icons/Brightness3";
import BrightnessHighIcon from "@material-ui/icons/BrightnessHigh";
import IconButton from '@material-ui/core/IconButton';

const SwitchColor = props => {
  return (
   <>
      {props.isChecked ? (
         <IconButton 
         
          aria-label="light mode" 
          component="span"  
          color="inherit"
          onClick={() => props.switchColor()}>
            <BrightnessHighIcon />
        </IconButton>
      ) : (
        <IconButton 
       
        aria-label="dark mode" 
        component="span" 
        color="inherit"
        onChange={() => props.switchColor()}>
          <Brightness3Icon onClick={() => props.switchColor()} />
      </IconButton>
        
      )}
    </>
  );
};

const mapStateToProps = state => {
  return {
    isChecked: state.switchColor
  };
};

export default connect(mapStateToProps, actionCreators)(SwitchColor);
